import { Helmet } from 'react-helmet-async';
import { useStoreInfo } from '@/lib/store';

export function ReturnPolicyPage() {
  const { storeInfo } = useStoreInfo();
  const pageTitle = `Return Policy${storeInfo?.site_name ? ` - ${storeInfo.site_name}` : ''}`;

  const policyLines = (storeInfo?.returnPolicy || '').split('\n').filter(Boolean);
  const defaultPolicy = [
    `At ${storeInfo?.site_name || 'our store'}, we do not accept returns or exchanges for any products purchased.`,
    'Refunds can only be processed for orders within 24 hours of placement. After 24 hours, all sales are final.',
    'Please carefully review your order before completing your purchase, including product selections, quantities, delivery address, and contact information.',
    'If you receive a damaged or incorrect item, contact us immediately at ' + (storeInfo?.contact_email || 'our contact email') + '. We will assess the situation and work to resolve any issues.',
    'If you have any questions about our policy, please contact our customer service team.'
  ];

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content="Our return policy" />
      </Helmet>

      <div className="min-h-screen bg-gray-50 py-12">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Return Policy</h1>

            <div className="prose prose-lg space-y-6">
              {policyLines.length > 0 ? (
                policyLines.map((line, index) => (
                  <p key={index}>{line}</p>
                ))
              ) : (
                defaultPolicy.map((line, index) => <p key={index}>{line}</p>)
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}